/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ProductToastNotification.tsx
 *
 * Project Title :  Checkout
 *
 * Description	: UT test cases for ProductAddedNotification.tsx
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422336
 *
 * @Date			: Oct 01 2020
 *
 * @Version      : Version 1.0
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3261 UI Enhancements for phase-2 bugfixes
 *
*******************************************************************************/

import React from 'react';
import { Notification } from '@scuf/common';
import { CheckoutUILabels } from '../constants/checkout-constants';
import RouteConstants from '../constants/route-constants';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ProductAlertActions from '../redux/actions/products-alerts-action';
import { ContactUsMessage } from '../Common/ContactUsMessage';

interface IToast {
    productCtg: string;
    closeToast: any;
    hideAlert: Function;
    success: boolean;
}

class ProductToastNotification extends React.Component<IToast & RouteComponentProps> {
    constructor(props: IToast & RouteComponentProps) {
        super(props);
        this.onHandleViewCart = this.onHandleViewCart.bind(this);
        this.onHandleClose = this.onHandleClose.bind(this);
    }

    onHandleViewCart() {
        this.onHandleClose();
        this.props.history.push(RouteConstants.MY_CART);
    }

    onHandleClose() {
        this.props.hideAlert();
    }

    render() {
        return (
            <React.Fragment>
                {this.props.success ?
                    <Notification
                        className="toast-notification"
                        hasIcon={true}
                        title={CheckoutUILabels.ADD_TO_CART_SUCCESS_HEADING}
                        severity="success"
                        detailsText="CHECKOUT"
                        onDetailsClick={this.onHandleViewCart}
                        onCloseClick={this.props.closeToast}
                    >
                    {this.props.productCtg + CheckoutUILabels.ADDED_TO_CART_SUCCESS_MSG }
                    </Notification> :
                    <Notification
                        hasIcon={true}
                        title={'unable to add' + this.props.productCtg + ' in your cart.'}
                        severity="critical"
                        onCloseClick={this.onHandleClose}
                    >
                        <ContactUsMessage>Please try again. {CheckoutUILabels.IF_ISSUE_PERSISTS}</ContactUsMessage>
                    </Notification>
                }
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    hideAlert: ProductAlertActions.hideAlert,
};

export default connect(null, mapDispatchToProps)(withRouter(ProductToastNotification));
